import React from "react";
import AccountRoute from "../../features/account/AccountRoute";
import HexAuthWrapper from "../../components/HexAuthWrapper";

const AccountSettings = () => (
  <div className="account-page full-bleed">
    <HexAuthWrapper>
      <AccountRoute />
    </HexAuthWrapper>
  </div>
);

export default AccountSettings;
